import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Table, Button, Spinner, Modal, Dropdown } from 'react-bootstrap';
import classNames from 'classnames';
import Flex from '../../common/Flex';
import Avatar from '../../common/Avatar';
import { list, remove } from '../../../lib/api/coach';
import { Add } from './Add';
import { Edit } from './Edit';
import { List as EditContact } from '../contact/Lista';
import SearchCoachAccordion from '../../common/SearchCoachAccordion';
import CardDropdown from 'components/common/CardDropdown';

export const List = () => {
  const [search, setSearch] = useState({});
  const [coachs, setCoachs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);
  const [selectedCoach, setSelectedCoach] = useState(null);

  const user = JSON.parse(localStorage.getItem('user'));

  const handleNew = () => {
    setSelectedCoach(null);
    setShowModal(true);
  };

  const handleEdit = id => {
    const coach = coachs.find(c => c.document_guid === id);
    setSelectedCoach(coach);
    setShowModal(true);
  };

  const handleContact = id => {
    const coach = coachs.find(c => c.document_guid === id);
    setSelectedCoach(coach);
    setShowContactModal(true);
  };

  const handelDelete = async id => {
    setIsLoading(true);
    try {
      if (confirm('Da li ste sigurni da zelite da izbrisete trenera?')) {
        await remove(id);
        setCoachs(coachs.filter(item => item.document_guid !== id));
      }
    } catch (error) {
      console.error('Failed to delete item', error);
    } finally {
      setIsLoading(false);
    }
  };

  const getCoachs = data => {
    setIsLoading(true);
    list(data)
      .then(res => setCoachs(res))
      .catch(err => console.error(err))
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    getCoachs(search);
  }, [search]);

  const getCoachName = item => `${item.name} ${item.last_name}`;

  const renderActions = item => (
    <CardDropdown>
      <div className="py-2">
        <Dropdown.Item onClick={() => handleContact(item.document_guid)}>Kontakti</Dropdown.Item>
        <Dropdown.Item onClick={() => handleEdit(item.document_guid)}>Izmjeni</Dropdown.Item>
        <Dropdown.Item className="text-danger" onClick={() => handelDelete(item.document_guid)}>
          Delete
        </Dropdown.Item>
      </div>
    </CardDropdown>
  );

  return (
    <>
      <Row className="g-3">
        <SearchCoachAccordion
          handleSearch={data => {
            setSearch(data);
          }}
        />
        <Col xs={12}>
          <Card className={classNames('h-100')}>
            <Card.Header>
              <Row className={classNames('g-2')}>
                <Col>
                  <Flex>
                    <h5 className="mb-0 hover-actions-trigger text-truncate text-nowrap">
                      Spisak trenera
                    </h5>
                  </Flex>
                </Col>
                <Col xs="auto">
                  {!user.club_guid ? (
                    <Button onClick={handleNew} variant="primary">
                      Dodaj trener
                    </Button>
                  ) : (
                    ''
                  )}
                </Col>
              </Row>
            </Card.Header>
            <Card.Body className="bg-body-tertiary">
              {isLoading ? (
                <div className="text-center">
                  <Spinner animation="border" role="status" />
                </div>
              ) : (
                <Row className="mb-3">
                  <div className="d-none d-xl-block">
                    <Table responsive className="mb-0">
                      <thead>
                        <tr>
                          <th scope="col">Ime i prezime</th>
                          <th scope="col">Vrsta</th>
                          <th scope="col">Broj licence</th>
                          <th className="text-end" scope="col">
                            Akcija
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {coachs.map((item, i) => (
                          <tr key={i}>
                            <td className="text-nowrap">
                              <div className="d-flex align-items-center">
                                <Avatar
                                  src={`${process.env.REACT_APP_BASE_API_URL}/uploads/${item.image_path}`}
                                  size="2xl"
                                  name={item.name}
                                />
                                <div className="ms-2">{getCoachName(item)}</div>
                              </div>
                            </td>
                            <td>
                              <div className="ms-2">{item.license_name}</div>
                            </td>
                            <td>
                              <div className="ms-2">{item.license}</div>
                            </td>
                            <td className="text-end">{renderActions(item)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>

                  <div className="d-xl-none">
                    <Row className="g-3">
                      {coachs.map(item => (
                        <Col xs={12} key={item.document_guid}>
                          <div
                            className="border rounded-4 bg-white h-100 p-3 shadow-sm"
                            style={{ borderColor: '#dfe3ee' }}
                          >
                            <div className="d-flex align-items-start justify-content-between gap-3">
                              <div className="flex-shrink-0">
                                <Avatar
                                  src={`${process.env.REACT_APP_BASE_API_URL}/uploads/${item.image_path}`}
                                  size="2xl"
                                  name={item.name}
                                />
                              </div>
                              <div className="flex-shrink-0">{renderActions(item)}</div>
                            </div>

                            <div className="mt-3">
                              <div className="fw-semibold text-dark fs-8">
                                {getCoachName(item)}
                              </div>

                              <div className="d-flex flex-wrap gap-2 mt-2">
                                <span className="badge rounded-pill badge-subtle-success">
                                  {item.license_name || '-'}
                                </span>
                                <span className="badge rounded-pill badge-subtle-primary">
                                  {item.license || '-'}
                                </span>
                              </div>
                            </div>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </div>
                </Row>
              )}
            </Card.Body>

            <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
              <Modal.Header closeButton>
                <Modal.Title>{selectedCoach ? 'Izmijeni trenera' : 'Dodaj trenera'}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {selectedCoach ? (
                  <Edit
                    initialData={selectedCoach}
                    onClose={() => setShowModal(false)}
                    onSave={getCoachs}
                  />
                ) : (
                  <Add onClose={() => setShowModal(false)} onSave={getCoachs} />
                )}
              </Modal.Body>
            </Modal>

            <Modal show={showContactModal} onHide={() => setShowContactModal(false)} size="lg">
              <Modal.Header closeButton>
                <Modal.Title>Kontakt</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <EditContact
                  initPartner={selectedCoach}
                  onClose={() => setShowContactModal(false)}
                />
              </Modal.Body>
            </Modal>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default List;
